import { SimpleTooltip } from '@bambi/component-library/src/components/Tooltip/SimpleTooltip';
import { sortBy } from 'lodash-es';

import { InvoicePaymentRead } from 'src/common/external/bambi-api/bambiApi';
import { Tag } from 'src/common/tags/Tag/Tag';

import { TagColumnWrapper } from './TagColumnWrapper';
import { useChargeStatusToLabel } from './useStatusToLabel';

export function ChargeStatusCell({
  payments,
}: {
  payments: InvoicePaymentRead[];
}) {
  const sortedPayments = sortBy(payments, 'created_at').reverse();
  // Being explicit on this type because sortedPayments is potentially empty
  const lastPayment = sortedPayments[0] as InvoicePaymentRead | undefined;
  const result = useChargeStatusToLabel(lastPayment?.charge_status!);

  if (!lastPayment || !result) {
    return null;
  }

  const { color, label } = result;

  return (
    <SimpleTooltip
      content={
        lastPayment.charge_status === 'failed'
          ? lastPayment.failure_message
          : null
      }
      testId="last-charge-status"
      trigger={
        <TagColumnWrapper>
          <Tag color={color} label={label} />
        </TagColumnWrapper>
      }
    />
  );
}
